import React from 'react';
import { useTranslation } from 'react-i18next';
import { MetaDataText } from './MediaTeaserParts.styles';
import { leadOrDescription } from '../../../../../play-core/utils/string-helper';
import { useVideoConfig } from '../../../config/VideoAppContext';
import { useHydrated } from '../../../hooks/use-hydrated';
import { useMediaTeaserConfig } from '../../../providers/UiConfigProvider/UiConfigContext';
import { formatSeason, dateOrWebFirstText, getMediaTitleWithEpisodeAndSeasonNumber } from '../../../utils/media-helper';
import { createSeparatedList } from '../../../utils/separated-list-helper';
import { DotSeparator } from '../../DotSeparator/DotSeparator';
import { jsx as _jsx } from "react/jsx-runtime";
export const useMediaInformation = media => {
  const {
    t
  } = useTranslation();
  const {
    businessUnit
  } = useVideoConfig();
  const {
    displayShowTitle,
    displayDate,
    displaySeasonAndEpisodes
  } = useMediaTeaserConfig();
  const isHydrated = useHydrated();
  const {
    show,
    episodeNumber,
    seasonNumber,
    title,
    date
  } = media;
  const showSeasonAndEpisode = displaySeasonAndEpisodes?.topics.some(topic => show?.topicList?.includes(topic));
  const formattedSeason = showSeasonAndEpisode ? formatSeason(seasonNumber, episodeNumber) : null;
  const list = [displayShowTitle && show && /*#__PURE__*/_jsx(MetaDataText, {
    shrink: !!formattedSeason,
    children: show.title
  }), showSeasonAndEpisode ? formattedSeason && /*#__PURE__*/_jsx(MetaDataText, {
    shrink: false,
    children: formattedSeason
  }) : displayDate && /*#__PURE__*/_jsx(MetaDataText, {
    shrink: true,
    children: isHydrated ? dateOrWebFirstText(date, t) : '\u200B'
  })];
  return {
    meta: createSeparatedList(list, /*#__PURE__*/_jsx(DotSeparator, {})),
    title: showSeasonAndEpisode ? title : getMediaTitleWithEpisodeAndSeasonNumber(media, businessUnit, t),
    description: leadOrDescription(media),
    season: formattedSeason
  };
};